define.alias("shared/components/shared/social-identity/placeholder-item", "settings/components/shared/social-identity/placeholder-item");